export const RRS_HOME = {
  type: 'localBusiness',
  name: 'Scoopr',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  url: 'https://scoopr.no',
  description:
    'På 2 minutter sjekker du enkelt om du kan få lavere rente på forbrukslånet dit, lavest rente på nytt lån eller lavere pris på forsikring.',
};
